import $ from 'jquery';
import { searchQuickOrderParts } from '../search/quick-order-meilisearch.js';
import { getItemInventory } from '../ordering/inventory.js';
import {
    validateOrderRows,
    renameOrderRows,
} from '../ordering/validation.js';
import { spinnerHtml } from '../core/utilities.js';

var $suggestionMount = null;
var activePartInputEl = null;
var searchSeq = 0;
var hideTimer = null;
var KEY_DOWN = 40;
var KEY_UP = 38;
var KEY_ENTER = 13;
var KEY_ESC = 27;

function ensureSuggestionMount() {
    if ($suggestionMount && $suggestionMount.length) {
        return $suggestionMount;
    }
    $suggestionMount = $(
        '<div id="quick-order-suggestions-mount" class="quick-order-suggestions shadow" role="listbox" aria-label="Part suggestions" />'
    );
    $('body').append($suggestionMount);
    return $suggestionMount;
}

function hideSuggestions() {
    if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
    }
    if ($suggestionMount) {
        $suggestionMount.empty().hide();
    }
    activePartInputEl = null;
}

function scheduleHide() {
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
        hideSuggestions();
    }, 200);
}

function cancelScheduledHide() {
    if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
    }
}

function positionSuggestions($input) {
    var el = $input[0];
    if (!el) return;
    var r = el.getBoundingClientRect();
    var $m = ensureSuggestionMount();
    var w = Math.max(320, r.width);
    $m.css({
        position: 'fixed',
        left: Math.min(r.left, window.innerWidth - w - 8) + 'px',
        top: r.bottom + 4 + 'px',
        width: w + 'px',
        zIndex: 1080,
        display: 'block',
    });
}

function applyPartSelection($table, $row, brandCode, partRaw) {
    var $brand = $row.find('.multi-order-brand');
    var $part = $row.find('.multi-order-part-number');
    var $gtin = $row.find('.multi-order-gtin');
    var gtin = $gtin.val() != undefined ? $gtin.val().trim() : '';

    if ($row.hasClass('default-row')) {
        var $clone = $table.find('.default-row').clone();
        $clone.find('.multi-order-part-number').val('');
        $clone.find('optgroup, .hr').remove();
        $clone.appendTo($table.find('tbody'));
        $row.removeClass('default-row');
        $row.find('.multi-order-quantity').prop('disabled', false);
        renameOrderRows($table);
    }

    hideSuggestions();
    $brand.find('option[value="' + brandCode + '"]')
        .not('.match')
        .prop('selected', true);
    $part.val(partRaw);
    getItemInventory($row, {
        aaia: brandCode,
        partnumber: partRaw,
        gtin: gtin,
    });
    validateOrderRows($table);
}

function renderSuggestionRows(rows, $input, $row, $table) {
    var $m = ensureSuggestionMount();
    $m.empty();
    rows.forEach(function (row, idx) {
        var label = row.BrandLabel ? ' — ' + row.BrandLabel : '';
        var $btn = $(
            '<button type="button" class="quick-order-suggestions__item dropdown-item text-start" role="option" />'
        );
        $btn.attr('id', 'quick-order-suggestion-' + idx);
        $btn.data('qoBrand', row.AAIABrandCode);
        $btn.data('qoPart', row.PartNumber);
        $btn.html(
            '<span class="fw-semibold">' +
                String(row.PartNumber || '') +
                '</span><span class="text-muted">' +
                String(label) +
                '</span>'
        );
        $m.append($btn);
    });
    $m.attr('aria-activedescendant', '');
    positionSuggestions($input);
    $m.off('mousedown.quickOrder').on('mousedown.quickOrder', function (e) {
        e.preventDefault();
    });
    $m.off('click.quickOrder', '.quick-order-suggestions__item')
        .on(
            'click.quickOrder',
            '.quick-order-suggestions__item',
            function (e) {
                e.preventDefault();
                var $b = $(this);
                applyPartSelection(
                    $table,
                    $row,
                    $b.data('qoBrand'),
                    $b.data('qoPart')
                );
            }
        );
}

function runPartSearch($input, $row, $table) {
    var q = $input.val().trim();
    var my = ++searchSeq;
    activePartInputEl = $input[0];

    if (q.length < 2) {
        hideSuggestions();
        return;
    }

    var $m = ensureSuggestionMount();
    $m.html(
        '<div class="p-3 text-muted small">' +
            spinnerHtml('Searching…') +
            '</div>'
    );
    positionSuggestions($input);
    $m.show();

    var brandFilter = ($row.find('.multi-order-brand').val() || '').trim();
    searchQuickOrderParts(q, { brandAaia: brandFilter }).then(function (rows) {
        if (my !== searchSeq || activePartInputEl !== $input[0]) {
            return;
        }
        if (!rows.length) {
            $m.html(
                '<div class="p-3 text-muted small">No matches — try another part #</div>'
            );
            positionSuggestions($input);
            return;
        }
        renderSuggestionRows(rows, $input, $row, $table);
    });
}

function moveActiveSuggestion(delta) {
    var $m = ensureSuggestionMount();
    if (!$m.is(':visible')) return;
    var $items = $m.find('.quick-order-suggestions__item');
    if (!$items.length) return;
    var $cur = $items.filter('.active');
    var idx = $cur.length ? $items.index($cur) : -1;
    $items.removeClass('active');
    var next = idx + delta;
    if (next < 0) next = $items.length - 1;
    if (next >= $items.length) next = 0;
    var $n = $items.eq(next);
    $n.addClass('active');
    $m.attr('aria-activedescendant', $n.attr('id') || '');
}

function activateHighlightedSuggestion($input, $row, $table) {
    var $m = ensureSuggestionMount();
    var $h = $m.find('.quick-order-suggestions__item.active');
    if (!$h.length) {
        $h = $m.find('.quick-order-suggestions__item').first();
    }
    if ($h.length) {
        applyPartSelection(
            $table,
            $row,
            $h.data('qoBrand'),
            $h.data('qoPart')
        );
    }
}

export function initQuickOrderModal() {
    var $modal = $('#orderModal');
    if (!$modal.length) {
        return;
    }

    var $form = $modal.find('form');

    $(window).on('resize.quickOrder scroll.quickOrder', function () {
        if (
            $suggestionMount &&
            $suggestionMount.is(':visible') &&
            activePartInputEl
        ) {
            positionSuggestions($(activePartInputEl));
        }
    });

    $modal.on('hidden.bs.modal.quickOrder', function () {
        hideSuggestions();
        searchSeq++;
    });

    $modal.on('shown.bs.modal.quickOrder', function () {
        hideSuggestions();
    });

    $modal.on(
        'focusin.quickOrder',
        '.multi-order-part-number',
        function () {
            activePartInputEl = this;
        }
    );

    $modal.on(
        'input.quickOrder',
        '.multi-order-part-number',
        function () {
            var $input = $(this);
            var $row = $input.closest('tr');
            var $table = $row.closest('.multi-order-table');
            runPartSearch($input, $row, $table);
            var q = $input.val().trim();
            if (!q.length) {
                $row.find('.multi-order-brand').find('optgroup, .hr').remove();
            }
        }
    );

    $modal.on(
        'keydown.quickOrder',
        '.multi-order-part-number',
        function (e) {
            var $m = ensureSuggestionMount();
            if (!$m.is(':visible') || !$m.find('.quick-order-suggestions__item').length) {
                return;
            }
            if (e.keyCode === KEY_DOWN) {
                e.preventDefault();
                moveActiveSuggestion(1);
            } else if (e.keyCode === KEY_UP) {
                e.preventDefault();
                moveActiveSuggestion(-1);
            } else if (e.keyCode === KEY_ENTER) {
                var $input = $(this);
                var $row = $input.closest('tr');
                var $table = $row.closest('.multi-order-table');
                e.preventDefault();
                activateHighlightedSuggestion($input, $row, $table);
            } else if (e.keyCode === KEY_ESC) {
                e.preventDefault();
                hideSuggestions();
            }
        }
    );

    $modal.on('blur.quickOrder', '.multi-order-part-number', function () {
        scheduleHide();
    });

    $modal.on('focus.quickOrder', '.multi-order-part-number', function () {
        cancelScheduledHide();
    });

    $(document).on('click.quickOrder', function (e) {
        if (!$suggestionMount || !$suggestionMount.is(':visible')) return;
        var t = e.target;
        if ($suggestionMount[0].contains(t)) return;
        if ($(t).closest('.multi-order-part-number').length) return;
        if ($(t).closest('#orderModal').length) hideSuggestions();
    });

    $modal.on(
        'paste input change keyup.quickOrderBrand',
        '.multi-order-brand',
        function (e) {
            var $self = $(this);
            var $table = $self.closest('.multi-order-table');
            var $row = $self.closest('tr');
            var $brand = $row.find('.multi-order-brand');
            var $partNumber = $row.find('.multi-order-part-number');
            var $gtin = $row.find('.multi-order-gtin');
            var brand = $brand.val() != null ? $brand.val().trim() : '';
            var partNumber = $partNumber.val().trim();
            var gtin = $gtin.val() != undefined ? $gtin.val().trim() : '';

            if ($row.hasClass('default-row') && brand.length > 0) {
                var $clone = $table.find('.default-row').clone();
                $clone
                    .find('.multi-order-part-number')
                    .val('');
                $clone.find('optgroup, .hr').remove();
                $clone.appendTo($table.find('tbody'));
                $row.removeClass('default-row');
                $row.find('.multi-order-quantity').prop('disabled', false);
                renameOrderRows($table);
            }

            if (brand.length > 0) {
                var $defaultRow = $table.find('.default-row');
                $defaultRow.find('optgroup, .hr').remove();
                $defaultRow.find('.multi-order-part-number').val('');
                $brand.attr(
                    'title',
                    $brand.find('option[value="' + brand + '"]').text()
                );
                if (partNumber.length > 0) {
                    getItemInventory($row, {
                        aaia: brand,
                        partnumber: partNumber,
                        gtin: gtin,
                    });
                }
            }

            validateOrderRows($table);
            if (brand.length < 1 && partNumber.length > 0) {
                $modal.find('form .btn-add-to-order').prop('disabled', true);
            }
        }
    );

    $modal.on(
        'change.quickOrderQty',
        '.multi-order-quantity',
        function () {
            validateOrderRows(
                $(this).closest('.multi-order-table')
            );
        }
    );
}
